'use client';

import { Box } from '@terra/ui-styled-system';
import { TracesContent } from './TracesContent';
import { ExecutionsPageHeader } from './executions-header/ExecutionsPageHeader';

export function ExecutionsListContent() {
  return (
    <Box
      h="full"
      w="full"
      display="flex"
      flexDirection="column"
      overflow="hidden"
    >
      <TracesContent header={<ExecutionsPageHeader />} />
    </Box>
  );
}
